import { observable } from '@/libs/state'

const addMemberOpen$ = observable<boolean>(false)

export { addMemberOpen$ }
